/* 全局数据实例 其他数据采用模块化的方式 */
import Vue from 'vue'
import Vuex from 'vuex'
import createVuexAlong from 'vuex-along'
import dictionary from './modules/dictionary.js'
import serverApis from './modules/serverApis.js'
import article from './modules/article'

Vue.use(Vuex)
/* 全局变量 */
const state = {
  userToken: null, // 用户登录成功后返回的token
  searchedStockId: ''
}
/* const getters = {
  getStateStockId: function (state) {
    return state.searchedStockId
  }
} */
const mutations = {
  updateSearchedStockId (state, searchedStockId) {
    state.searchedStockId = searchedStockId
  }
}
const actions = {
  getSearchedStockId (context, searchedStockId) {
    context.commit('updateSearchedStockId', searchedStockId)
  }
}

/* 在这里添加模块 */
const modules = {
  dictionary,
  serverApis,
  article
}
export default new Vuex.Store({
  state,
  // getters,
  actions,
  mutations,
  modules,
  strict: 'debug',
  plugins: [createVuexAlong()]
})
/* export default new Vuex.Store({
  modules: { /!* 在这里添加模块 *!/
    dictionary,
    serverApis
  },
  state: { /!* 全局变量 *!/
    // 用户登录成功后返回的token
    userToken: null,
    searchedStockId: ''
  },
  strict: 'debug'
}) */



// WEBPACK FOOTER //
// ./src/store/index.js